import { Button, Typography, useTheme, Box } from "@mui/material";
import { useContext } from "react";
import { AppContext } from "../../contextProviders/AppContext";
import { translation } from "../Dictionary";
import DateRangeMobileDialog from "./DateRangeMobileDialog";

import { format, isValid } from "date-fns";

export default function DatePickerMobile({
  companyOpenHours,
  getMinimumDate,
  openDateRangeMobile,
  returnTimeLabel,
  startTimeLabel,
  setOpenDateRangeMobile,
  startDateString,
  VUOKRAAPAKU_SPECIAL_COMPANY,
  companyOpenHoursReturn,
  selectedPicker,
  setSelectedPicker,
  handleChangeDate,
  deliveryBufferTime,
}) {
  const theme = useTheme();
  const {
    language,
    locale,
    endTimeOk,
    hasError,
    selectedCompany,
    selectedTimeFrame,
    selectedDateRange,
    setSelectedTimeFrame,
  } = useContext(AppContext);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        marginTop: "5px",
        width: "100%",
      }}
    >
      <Box
        sx={{
          justifyContent: "center",
          position: "relative",
          transition: "ease-in-out 150ms",
          direction: "row",
          marginTop: "5px",
        }}
      >
        <Button
          fullWidth
          sx={{
            display: "flex",
            cursor: "pointer",
            padding: "10px",
            height: "70px",
            border: "1px solid lightgrey",
            bgcolor: theme.palette.primary.dialogBackground,
            borderRadius: "15px",
          }}
          onClick={() => setOpenDateRangeMobile(true)}
          disabled={!selectedCompany}
        >
          <Typography sx={{ fontFamily: "Sofia Pro", fontSize: "16px" }}>
            {selectedDateRange[0] == null && (
              <>{translation.get(language, "Daterange select title")}</>
            )}
            {selectedDateRange[1] != null && (
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography
                  sx={{
                    fontFamily: "Sofia Pro",
                    fontSize: "16px",
                    color: theme.palette.primary.mainText,
                  }}
                >
                  {translation.get(language, "Daterange schedule text")}
                </Typography>
                {isValid(selectedDateRange[0]) &&
                isValid(selectedDateRange[1]) ? (
                  <Typography variant="caption">
                    {format(selectedDateRange[0], "dd.MM HH:mm", {
                      locale: locale,
                    })}{" "}
                    -{" "}
                    {format(selectedDateRange[1], "dd.MM HH:mm", {
                      locale: locale,
                    })}
                  </Typography>
                ) : (
                  ""
                )}
              </Box>
            )}
          </Typography>
        </Button>

        <DateRangeMobileDialog
          selectedPicker={selectedPicker}
          setSelectedPicker={setSelectedPicker}
          companyOpenHours={companyOpenHours}
          startTimeLabel={startTimeLabel}
          companyOpenHoursReturn={companyOpenHoursReturn}
          getMinimumDate={getMinimumDate}
          openDateRangeMobile={openDateRangeMobile}
          returnTimeLabel={returnTimeLabel}
          setOpenDateRangeMobile={setOpenDateRangeMobile}
          startDateString={startDateString}
          VUOKRAAPAKU_SPECIAL_COMPANY={VUOKRAAPAKU_SPECIAL_COMPANY}
          handleChangeDate={handleChangeDate}
          deliveryBufferTime={deliveryBufferTime}
        />
      </Box>
    </Box>
  );
}
